import { useMutation, useQuery } from '@tanstack/react-query';

import {
  type DriverSafetyRow,
  type FleetSafetyAggregatedBy,
  type FleetSafetyReportRequest,
  type FleetSafetyRequest,
  FleetSafetyRequester,
  type FleetSafetyResponse,
} from '@cobliteam/api-lib';

import { Environment } from '@cobliteam/react-environments';

const env = Environment.getInstance().getEnvironment();
const fleetSafetyRequester = new FleetSafetyRequester({ host: env.apiHost });

const LEGACY_QUERY_KEY = 'DRIVER_SAFETY';
const QUERY_KEY = 'FLEET_SAFETY';

const useGetLegacyDriverSafetyRows = (request: FleetSafetyRequest) =>
  useQuery<DriverSafetyRow[]>({
    queryKey: [LEGACY_QUERY_KEY, 'ROWS', JSON.stringify(request)],
    queryFn: () => fleetSafetyRequester.getLegacyDriverSafety(request),
    staleTime: 300000,
  });

const useGetSafetyRows = (
  request: FleetSafetyRequest,
  aggregatedBy: FleetSafetyAggregatedBy
) =>
  useQuery<FleetSafetyResponse>({
    queryKey: [QUERY_KEY, 'ROWS', JSON.stringify(request), aggregatedBy],
    queryFn: () => fleetSafetyRequester.getFleetSafety(request, aggregatedBy),
    staleTime: 300000,
  });

const useRequestSafetyReport = () =>
  useMutation<string, unknown, { request: FleetSafetyReportRequest }>({
    mutationFn: (variables) =>
      fleetSafetyRequester.requestFleetSafetyReport(variables.request),
  });

export default {
  useGetLegacyDriverSafetyRows,
  useGetSafetyRows,
  useRequestSafetyReport,
};
